import React, { useState, useEffect } from 'react';

export default function SourcesEditor({ sources = [], onSave, onClose }) {
  const [items, setItems] = useState(sources.map(s => ({ ...s })));

  const addItem = () => setItems([...items, { name: '', url: '' }]);
  
  const updateItem = (idx, field, value) => {
    const updated = [...items];
    updated[idx] = { ...updated[idx], [field]: value };
    setItems(updated);
  };

  const removeItem = (idx) => setItems(items.filter((_, i) => i !== idx));

  const handleSave = () => {
    const cleaned = items.filter(s => s.name.trim() || s.url.trim());
    onSave(cleaned);
    onClose();
  };

  return (
    <div className="admin-modal-backdrop" onClick={onClose}>
      <div className="admin-modal" onClick={e => e.stopPropagation()}>
        <div className="admin-modal-header">
          <h3>Edit Sources</h3>
          <button className="admin-modal-close" onClick={onClose}>×</button>
        </div>
        <div className="admin-modal-body">
          {items.map((item, idx) => (
            <div key={idx} className="admin-source-row">
              <input
                type="text"
                placeholder="Source name"
                value={item.name}
                onChange={e => updateItem(idx, 'name', e.target.value)}
                className="admin-input"
              />
              <input
                type="url"
                placeholder="https://..."
                value={item.url}
                onChange={e => updateItem(idx, 'url', e.target.value)}
                className="admin-input"
              />
              <button className="admin-btn-remove" onClick={() => removeItem(idx)} title="Remove">×</button>
            </div>
          ))}
          <button className="admin-btn-add" onClick={addItem}>+ Add source</button>
        </div>
        <div className="admin-modal-footer">
          <button className="admin-btn-secondary" onClick={onClose}>Cancel</button>
          <button className="admin-btn-primary" onClick={handleSave}>Save</button>
        </div>
      </div>
    </div>
  );
}
